import { render } from "./GradBook.vue?vue&type=template&id=245f7f0a&scoped=true"
import script from "./GradBook.vue?vue&type=script&lang=js"
export * from "./GradBook.vue?vue&type=script&lang=js"

import "./GradBook.vue?vue&type=style&index=0&id=245f7f0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245f7f0a"]])

export default __exports__